module.exports = __webpack_public_path__ + "img/Hero-Illustration.6ca41664.svg";